import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { environment } from 'environments';
import { Rule } from 'types';

export const fetchRules = createAsyncThunk('get:rules', async () => {
  const { data } = await axios.get<Rule[]>(`${environment.baseApiUrl}rules`);

  return data;
});

export const updateRule = createAsyncThunk('patch:admin/rules', async (rule: Rule) => {
  const { compensationType, legalEntity, requiresBill, fixedAmount, amount, amountPercent, amountLimit } = rule;

  await axios.patch(`${environment.baseApiUrl}admin/rules/${legalEntity}/${compensationType}`, {
    requiresBill,
    fixedAmount,
    amount,
    amountPercent,
    amountLimit,
  });

  return rule;
});
